import { createPortal } from 'react-dom';

const LogOutConfirmModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="bg-slate-900 fixed inset-0 z-50 flex items-center justify-center bg-opacity-60 backdrop-blur-sm">
      <div className="mx-auto w-full max-w-md rounded-xl border border-gray-200 bg-white p-6 shadow-lg">
        <div className="mb-4 flex items-center justify-center">
          <svg
            className="h-8 w-8 text-amber-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            ></path>
          </svg>
          <h3 className="ml-2 text-xl font-bold text-gray-800">
            Sign Out Confirmation
          </h3>
        </div>

        <p className="mb-6 text-center text-gray-600">
          You are about to sign out from the institution portal. Any unsaved
          work may be lost.
        </p>

        <div className="grid grid-cols-2 gap-4">
          <button
            className="rounded-lg border border-gray-300 bg-white py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            onClick={onClose}
          >
            Stay Signed In
          </button>
          <button
            className="rounded-lg bg-brand-600 py-2 text-sm font-medium text-white shadow-sm hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            onClick={onConfirm}
          >
            Sign Out
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default LogOutConfirmModal;
